import ApiManager from '../../../utils/ApiManager'
import Constants from '@/utils/Constants'
import axios from 'axios'

class AnalyzeResultService {
  async getResultData (analyzeCode, historyId, type, pageNo, pageSize, sortField, sortType) {
    let params = {
      type: type,
      id: historyId,
      page_no: pageNo,
      page_size: pageSize,
      sort_field: sortField,
      sort_type: sortType
    }
    let response = null
    if (analyzeCode === 'IF00001') {
      response = await ApiManager.request('Result').resultDataIf00001(params)
    } else if (analyzeCode === 'IF00002') {
      response = await ApiManager.request('Result').resultDataIf00002(params)
    } else if (analyzeCode === 'IF00003') {
      response = await ApiManager.request('Result').resultDataIf00003(params)
    } else if (analyzeCode === 'IF00004') {
      response = await ApiManager.request('Result').resultDataIf00004(params)
    } else if (analyzeCode === 'IF00005') {
      response = await ApiManager.request('Result').resultDataIf00005(params)
    } else if (analyzeCode === 'IF00006') {
      response = await ApiManager.request('Result').resultDataIf00006(params)
    } else if (analyzeCode === 'IF00007') {
      response = await ApiManager.request('Result').resultDataIf00007(params)
    } else if (analyzeCode === 'IF00008') {
      response = await ApiManager.request('Result').resultDataIf00008(params)
    } else if (analyzeCode === 'IF00010') {
      response = await ApiManager.request('Result').resultDataIf00010(params)
    } else if (analyzeCode === 'IF00011') {
      response = await ApiManager.request('Result').resultDataIf00011(params)
    } else {
      response = await ApiManager.request('Result').resultDataIf00001(params)
    }
    return response
  }

  async getDatas (analyzeCode, historyId, type, whereCondition) {
    let params = {
      type: type,
      id: historyId,
      page_no: -1,
      where_condition: whereCondition
    }
    let response = null
    if (analyzeCode === 'IF00001') {
      response = await ApiManager.request('Result').resultDataIf00001(params)
    } else if (analyzeCode === 'IF00002') {
      let whereCondition = {
        fixed_groupby: type,
        gender: '',
        // sum_row: 'man_total'
        sum_row: ''
      }
      params.where_condition = whereCondition
      response = await ApiManager.request('Result').resultDataIf00002(params)
    } else if (analyzeCode === 'IF00003') {
      response = await ApiManager.request('Result').resultDataIf00003(params)
    } else if (analyzeCode === 'IF00004') {
      response = await ApiManager.request('Result').resultDataIf00004(params)
    } else if (analyzeCode === 'IF00005') {
      response = await ApiManager.request('Result').resultDataIf00005(params)
    } else if (analyzeCode === 'IF00006') {
      response = await ApiManager.request('Result').resultDataIf00006(params)
    } else if (analyzeCode === 'IF00007') {
      response = await ApiManager.request('Result').resultDataIf00007(params)
    } else if (analyzeCode === 'IF00008') {
      response = await ApiManager.request('Result').resultDataIf00008(params)
    } else {
      response = await ApiManager.request('Result').resultDataIf00001(params)
    }
    return response
  }

  /**
   * id:
   * mailNeed:
   * type:
   */
  async downloadReport (params) {
    let config = {
      baseURL: Constants['apiEndPoint'],
      headers: {
        Authorization: 'bearer ' + Constants.getToken()
      },
      responseType: 'blob',
      timeout: 300000
    }

    let api = '/result/excel'
    if (params.export_type === 1) {
      api = '/result/csv'
    }
    return axios.post(api, params, config).catch(err => {
      console.log(err.response)
      return Promise.reject(err)
    })
  }

  async downloadItems (params) {
    let config = {
      baseURL: Constants['apiEndPoint'],
      headers: {
        Authorization: 'bearer ' + Constants.getToken()
      },
      responseType: 'blob'
    }

    let api = ''
    if (params.export_type === 1) {
      api = '/result/item_base'
    }
    if (params.export_type === 2) {
      api = '/result/item_target'
    }
    return axios.post(api, params, config)
  }

  async getChartData (historyId, type, yAxis) {
    let config = {
      baseURL: Constants['apiEndPoint'],
      headers: {
        Authorization: 'bearer ' + Constants.getToken()
      }
    }

    let params = {
      type: type,
      id: historyId,
      page_no: -1,
      where_condition: {
        fixed_groupby: type,
        y_axis: yAxis
      }
    }

    return axios.post('/result/chart_data', params, config)
  }
}

export default new AnalyzeResultService()
